import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TICKETS_API = '/api/tickets';
const MASTER_DATA_API = '/api/master-data';

const Icon = ({ d, size = 16, strokeWidth = 1.75 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24"
        fill="none" stroke="currentColor"
        strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
        {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
    </svg>
);

const icons = {
    plus: ['M12 5v14', 'M5 12h14'],
    search: ['M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z', 'M21 21l-4.35-4.35'],
    refresh: ['M23 4v6h-6', 'M1 20v-6h6', 'M3.51 9a9 9 0 0 1 14.85-3.36L23 10', 'M1 14l4.64 4.36A9 9 0 0 0 20.49 15'],
    trash: ['M3 6h18', 'M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2', 'M10 11v6', 'M14 11v6'],
    reply: ['M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 1 1-7.6-11.7 1 1 0 0 1 1 1 8.5 8.5 0 0 1-1.3 4.4l3.8 3.8a1 1 0 0 1 0 1.4z', 'M3 21l1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z'],
};

export default function Tickets({ onReply, onCreate }) {
    const [tickets, setTickets] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');

    const fetchTickets = async () => {
        setLoading(true);
        try {
            const [tRes, sRes] = await Promise.all([
                axios.get(TICKETS_API),
                axios.get(MASTER_DATA_API)
            ]);
            setTickets(tRes.data);
            setStatuses(sRes.data.filter(i => i.category === 'ticket-status'));
        } catch (err) {
            console.error('Error fetching tickets:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTickets();
    }, []);

    const handleDelete = async (e, id) => {
        e.stopPropagation();
        if (!window.confirm("Are you sure you want to delete this ticket?")) return;
        try {
            await axios.delete(`${TICKETS_API}/${id}`);
            fetchTickets();
        } catch (err) {
            console.error("Delete error:", err);
            alert("Failed to delete ticket");
        }
    };

    const tdStyle = { padding: '12px 16px', borderBottom: '1px solid #f1f5f9', fontSize: '14.49px', color: '#1e293b', verticalAlign: 'middle' };
    const thStyle = { background: '#f8fafc', color: '#64748b', fontWeight: 'bold', fontSize: '13.36px', padding: '12px 16px', borderBottom: '1px solid #e2e8f0', textAlign: 'left', textTransform: 'uppercase' };

    return (
        <div style={{ padding: '24px 32px', background: '#f8fafc', minHeight: 'calc(100vh - 70px)' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
                <h1 style={{ fontSize: '26.74px', fontWeight: 'bold', color: '#1e293b', margin: 0 }}>Ticket Index</h1>
                <div style={{ display: 'flex', gap: '12px' }}>
                    <button style={{
                        padding: '8px 16px', borderRadius: '6px', border: '1px solid #e2e8f0', background: '#fff',
                        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '15.60px', cursor: 'pointer', color: '#64748b'
                    }} onClick={fetchTickets}>
                        <Icon d={icons.refresh} size={15} /> Refresh
                    </button>
                    <button style={{
                        padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#1e293b',
                        display: 'flex', alignItems: 'center', gap: '8px', fontSize: '15.60px', cursor: 'pointer', color: '#fff'
                    }} onClick={onCreate}>
                        <Icon d={icons.plus} size={15} /> New Ticket
                    </button>
                </div>
            </div>

            <div style={{ background: '#fff', borderRadius: '12px', border: '1px solid #e2e8f0', padding: '20px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                    <div style={{ position: 'relative', width: '320px' }}>
                        <div style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }}>
                            <Icon d={icons.search} size={15} />
                        </div>
                        <input
                            type="text"
                            placeholder="Search tickets..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            style={{
                                width: '100%', padding: '10px 12px 10px 38px', borderRadius: '8px', border: '1px solid #e2e8f0',
                                outline: 'none', fontSize: '15.60px', boxSizing: 'border-box'
                            }}
                        />
                    </div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ ...thStyle, width: '40px' }}><input type="checkbox" /></th>
                                <th style={{ ...thStyle, width: '60px' }}>S.No</th>
                                <th style={thStyle}>Subject</th>
                                <th style={thStyle}>Status</th>
                                <th style={thStyle}>Priority</th>
                                <th style={thStyle}>Department</th>
                                <th style={thStyle}>Service</th>
                                <th style={thStyle}>Contact</th>
                                <th style={thStyle}>Created</th>
                                <th style={{ ...thStyle, textAlign: 'center', width: '120px' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="10" style={{ textAlign: 'center', padding: '60px', color: '#64748b' }}>Loading tickets...</td></tr>
                            ) : tickets.length === 0 ? (
                                <tr><td colSpan="10" style={{ textAlign: 'center', padding: '60px', color: '#64748b' }}>No entries found</td></tr>
                            ) : tickets.filter(t => (t.subject || '').toLowerCase().includes(search.toLowerCase())).map((ticket, idx) => (
                                <tr key={ticket._id} onClick={() => onReply(ticket)} style={{ cursor: 'pointer', borderBottom: '1px solid #f1f5f9', transition: 'background 0.15s' }}
                                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                                    onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                                >
                                    <td style={tdStyle}><input type="checkbox" onClick={e => e.stopPropagation()} /></td>
                                    <td style={{ ...tdStyle, color: '#64748b' }}>{idx + 1}</td>
                                    <td style={{ ...tdStyle, fontWeight: 600, color: '#0f172a' }}>{ticket.subject}</td>
                                    <td style={tdStyle}>
                                        <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                                            {ticket.tags && ticket.tags.length > 0 ? ticket.tags.map((tag, i) => {
                                                const matchedStatus = statuses.find(s => s.name.toLowerCase() === tag.toLowerCase());
                                                const color = matchedStatus?.color || '#64748b';
                                                return (
                                                    <span key={i} style={{
                                                        background: `${color}15`, color: color,
                                                        padding: '3px 10px', borderRadius: '12px', fontSize: '12.25px', fontWeight: 600
                                                    }}>{tag}</span>
                                                );
                                            }) : (
                                                <span style={{ color: '#94a3b8', fontSize: '13.36px' }}>—</span>
                                            )}
                                        </div>
                                    </td>
                                    <td style={tdStyle}>
                                        {ticket.priority ? (
                                            <span style={{
                                                background: `${ticket.priority.color || '#64748b'}15`,
                                                color: ticket.priority.color || '#64748b',
                                                padding: '3px 10px', borderRadius: '12px', fontSize: '12.25px', fontWeight: 600
                                            }}>{ticket.priority.name}</span>
                                        ) : '—'}
                                    </td>
                                    <td style={tdStyle}>{ticket.department?.name || '—'}</td>
                                    <td style={tdStyle}>{ticket.service?.name || '—'}</td>
                                    <td style={tdStyle}>
                                        {ticket.contactName || ticket.contactEmail
                                            ? <span>{ticket.contactName}{ticket.contactName && ticket.contactEmail ? ' - ' : ''}{ticket.contactEmail}</span>
                                            : '—'}
                                    </td>
                                    <td style={tdStyle}>{new Date(ticket.createdAt).toLocaleDateString()}</td>
                                    <td style={{ ...tdStyle, textAlign: 'center' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                            <button
                                                onClick={(e) => { e.stopPropagation(); onReply(ticket); }}
                                                title="Reply"
                                                style={{
                                                    background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8',
                                                    padding: '4px', borderRadius: '4px', display: 'inline-flex', transition: 'color 0.15s'
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.color = '#10b981'}
                                                onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}
                                            >
                                                <Icon d={icons.reply} size={15} />
                                            </button>
                                            <button
                                                onClick={(e) => handleDelete(e, ticket._id)}
                                                title="Delete"
                                                style={{
                                                    background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8',
                                                    padding: '4px', borderRadius: '4px', display: 'inline-flex', transition: 'color 0.15s'
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.color = '#ef4444'}
                                                onMouseLeave={e => e.currentTarget.style.color = '#94a3b8'}
                                            >
                                                <Icon d={icons.trash} size={15} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
